import React, { useEffect, memo } from 'react';
import { Form, Select, Input, FormModal, Col, Row } from 'components';

interface RejectModalProps {
  form: any;
  open: boolean;
  loading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  rejectionReasons: { label: string; value: string }[];
}

export const RejectModal: React.FC<RejectModalProps> = memo(
  ({ form, open, onSubmit, onCancel, loading, rejectionReasons }) => {
    useEffect(() => {
      if (open) {
        form.resetFields();
      }
    }, [form, open]);

    return (
      <FormModal
        form={form}
        width={400}
        loading={loading}
        title="Reject"
        open={open}
        onSubmit={onSubmit}
        onCancel={onCancel}
        disableOkBtn={false}
        okText="Reject"
        okButtonProps={{ danger: true }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="rejectionReason"
              label="Reason*"
              rules={[{ required: true, message: 'Please select a rejection reason' }]}
            >
              <Select size={'large'} options={rejectionReasons} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="additionalInformation" label="Additional Information">
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    );
  }
);
